import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import Image from '../../assets/img/service/case-1-1.jpg';

const SingleServiceFive = (props) => {
  const { itemClass, serviceImage, category, title, description, btnText } =
    props;
  return (
    <div className={itemClass ? itemClass : 'it-service-2-item item-style-3'}>
      <div className="it-service-2-thumb">
        <img src={serviceImage ? serviceImage : Image} alt="" />
      </div>
      <div className="it-service-2-content p-relative">
        <div className="it-service-2-category">
          <span>{category ? category : 'Depression'}</span>
        </div>
        <h4 className="it-service-title mb-15">
          <Link className="hover-anim grey" to="/service-details">
            {title ? title : 'Anxiety Disorder'}
          </Link>
        </h4>
        <p className="mb-20">
          {description
            ? description
            : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'}
        </p>
        <Link className="it-btn-theme service-btn" to="/service-details">
          <Button btnText={btnText ? btnText : 'Our Counseling'} />
        </Link>
      </div>
    </div>
  );
};

export default SingleServiceFive;
